
import { put, takeLatest } from "redux-saga/effects";
import axiosCustom from '../../../../components/common/apiConfig';
import { handleNotificationAlertTrySelect, handleNotificationAlertCatch } from "../../../../components/method/handleNotificationAlert";

export const  
actionTypes = {
    selectCheckGiftSerialSelect: "[selectCheckGiftSerialSelectGold] Action",
    selectCheckGiftSerialSelectAsync: "[selectCheckGiftSerialSelectAsyncGold] Action",
    selectCheckGiftSerialRemove: "[selectCheckGiftSerialRemoveGold] Action",
    selectCheckGiftSerialLoading: "[selectCheckGiftSerialLoadingGold] Action",

};

const initialState = {
    data: {},
    isOk: false,
    loading: false,
};


export const select_check_gift_serial_reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case actionTypes.selectCheckGiftSerialSelect:
            return {
                ...state,
                data: payload,
                isOk: true
            }
        case actionTypes.selectCheckGiftSerialLoading:
            return {
                ...state,
                loading: payload,
            }
        case actionTypes.selectCheckGiftSerialRemove:
            return initialState
        default:
            return state
    }
}

function* handleWorker({ payload }) {

    yield put({ type: actionTypes.selectCheckGiftSerialLoading, payload: true })
    let config = {
        url: "select_request",
    }

    let data = {
        table: "gift_card",
        method_type: "check_gift_serial",
        data: payload?.data ? payload?.data : {}
    }

    try {
        let res = yield axiosCustom(config, data)
        if (res?.data?.response?.error_code === 134301) {
            let dispachError = payload?.setErrors
            dispachError({ serial: res?.data?.response?.error_persian_description })
            return
        }

        let isOk = handleNotificationAlertTrySelect(res)
        if (!isOk) return

        yield put({ type: actionTypes.selectCheckGiftSerialSelect, payload: res?.data?.response?.data })


    } catch {
        handleNotificationAlertCatch()
    }
    finally {
        yield put({ type: actionTypes.selectCheckGiftSerialLoading, payload: false })
    }


}


export function* select_check_gift_serial_worker() {

    yield takeLatest(actionTypes.selectCheckGiftSerialSelectAsync, handleWorker)
}